module.exports = __webpack_public_path__ + "static/logo@2x-7d9ffc754b908d97aacf99d2eadf4572.png";